import React from "react";
import { useNavigate } from "react-router-dom";
import { Check, ArrowLeft } from "lucide-react";

const SuccessPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white flex items-center justify-center p-4 -mt-24">
      <div className="w-full max-w-2xl bg-[#EBF5FF] rounded-xl p-8 md:p-16 relative flex flex-col items-center text-center">
        
        {/* Back Arrow */}
        <button 
          onClick={() => navigate(-1)}
          className="absolute top-6 left-6 text-gray-700 hover:scale-110 transition-transform"
        >
          <ArrowLeft size={24} />
        </button>

        {/* Success Icon */}
        <div className="w-16 h-16 bg-[#3B82F6] rounded-full flex items-center justify-center mb-6 shadow-lg shadow-blue-200">
          <Check className="text-white" size={36} strokeWidth={3} />
        </div>

        {/* Text Content */}
        <h1 className="text-2xl md:text-3xl font-bold text-[#1E3A8A] mb-4">
          Order Placed Successfully!
        </h1>
        <p className="text-[#3B82F6] font-medium mb-10 max-w-sm">
          Thank you for your order. We'll send you a confirmation email shortly.
        </p>

        {/* Button */}
        <button
          onClick={() => navigate("/")}
          className="bg-[#3B82F6] hover:bg-blue-600 text-white px-10 py-3 rounded-md font-semibold transition-colors shadow-md"
        >
          Continue Shopping
        </button>
      </div>
    </div>
  );
};

export default SuccessPage;